var paragraph_default = {
  "fontElementMap": "wJ68J",
  "elementSpacing": "cQRuq",
  "text": "cqfST cQRuq",
  "child": "_61ACD"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
